import { Lock, Globe } from "lucide-react";
import ThreadPresenceBar from "./ThreadPresenceBar";

const ChatThreadHeader = ({
  presentUuids = [],
  threadTitle = "",
  chatType = "private",
}) => {
  return (
    <div className="absolute top-0 left-0 right-0 z-10 flex items-center justify-between h-14 px-4 border-b border-surfaceBorder bg-surface/80 backdrop-blur-sm">
      {/* Left: type icon + thread title */}
      <div className="flex items-center gap-2.5 min-w-0">
        {chatType === "public" ? (
          <Globe className="h-4 w-4 text-mutedText flex-shrink-0" />
        ) : (
          <Lock className="h-4 w-4 text-mutedText flex-shrink-0" />
        )}
        {threadTitle ? (
          <span className="text-[14px] font-medium text-mainText truncate">
            {threadTitle}
          </span>
        ) : (
          <span className="text-[13px] font-light text-mutedText italic">
            New thread
          </span>
        )}
        <span className="text-[11px] font-light text-mutedText flex-shrink-0">
          {chatType === "public" ? "Public" : "Private"}
        </span>
      </div>

      {/* Right: presence + future actions (search, etc.) */}
      <div className="flex items-center gap-2">
        <ThreadPresenceBar presentUuids={presentUuids} />
      </div>
    </div>
  );
};

export default ChatThreadHeader;
